<template>
    <!-- Mobile Menu -->
    <div class="dropdown mobile-user-menu">
      <a href="javascript:void(0);" class="nav-link dropdown-toggle" data-bs-toggle="dropdown"
        aria-expanded="false"><i class="fa fa-ellipsis-v"></i></a>
      <div class="dropdown-menu dropdown-menu-right">
        <!-- Branch List -->
        <div class="dropdown-item-text fw-bold text-muted px-3">Select Branch</div>
        <a
          v-for="(item, index) in branchList"
          :key="index"
          class="dropdown-item"
          href="javascript:void(0);"
          @click="selectBranch(item)"
          :class="{ 'text-success fw-bold': filter == item.id }"
        >
          {{ item.text }}
        </a>
        <div class="dropdown-divider"></div>
  
        <router-link class="dropdown-item" to="profile">My Profile</router-link>
        <a class="dropdown-item" @click="logOut">Logout</a>
      </div>
    </div>
</template>

<script>
import { logOut } from "@/assets/js/function";
import Cookies from "js-cookie";

export default {
  data() {
    return {
      branchList: [],
      filter: 0,
      token: "",
      config: "",
    };
  },
  created() {
    this.token = Cookies.get("token_refresh");
    Cookies.set("token_refresh_utama", this.token);
    this.config = {
      headers: { Authorization: `Bearer ` + this.token },
      timeout: 30000,
    };
    const selectedBranch = localStorage.getItem("selectedBranch");
    if(selectedBranch != null || selectedBranch != undefined || selectedBranch != ''){
        this.filter = selectedBranch;
    }
    this.getBranchFromIndex();
  },
  
  methods: {
    logOut,
    selectBranch(item) {
      
      this.filter = item.id;
      
      localStorage.setItem("selectedBranch", item.id);
      
      window.location.reload();
    },

    // for branch select
        getBranchFromIndex() {
            const raw = localStorage.getItem("company_list");
            if (!raw) return;
    
            try {
              const parsed = JSON.parse(raw); // convert JSON string to array
              this.branchList = [];
    
              // Push "All Branch" first
              // this.branchList.push({ id: 0, text: "All Branch"});
    
              // Push each company from localStorage
              parsed.forEach(item => {
                const item_prepare = {
                  id: item.id,
                  text: item.nama_lokasi,
                  
                };
                this.branchList.push(item_prepare);
              });
    
              // Optional: set default selected branch from localStorage
              const storedBranch = localStorage.getItem("selectedBranch");
              const exists = this.branchList.some(
                branch => String(branch.id) === String(storedBranch)
              );
    
              if (exists) {
                this.filter = storedBranch;
              } else {
                this.filter = 0;
                localStorage.setItem("selectedBranch", this.filter);
              }
    
            } catch (e) {
              console.error("Invalid JSON in company_list:", e);
            }
    
        },
    
  },
};
</script>
